import { colors } from '../../../../../packages/colors';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    height: 'calc(100vh - 238px)',
    overflowY: 'auto',
    // backgroundColor: colors.white,
  },
  contentRefill: {
    height: 'calc(100vh - 180px)',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.primary25,
    borderRadius: 8,
    border: `1px solid ${colors.primary100}`,
    padding: '16px 24px',
    gap: 16,
  },
  infoCard: {
    borderRadius: 8,
    border: `2px solid ${colors.primary500}`,
    padding: '16px 24px',
    backgroundColor: colors.white,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: colors.neutral800,
    lineHeight: '20px',
  },
  cardAction: {
    fontSize: 14,
    color: colors.primary500,
    cursor: 'pointer',
    fontWeight: 500,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  pharmacyName: {
    fontSize: 18,
    fontWeight: 600,
    color: colors.neutral900,
    lineHeight: '24px',
  },
  pharmacyAddress: {
    fontSize: 13,
    color: colors.neutral600,
    marginBottom: 2,
    lineHeight: '16px',
  },
  subText: {
    fontSize: 13,
    color: colors.neutral600,
    lineHeight: '16px',
    marginBottom: 2,
    whiteSpace: 'nowrap',
  },
  pharmacyFeature: {
    fontSize: 11,
    color: colors.success600,
    fontWeight: 500,
    lineHeight: '14px',
  },
  prescriptionItem: {
    fontSize: 13,
    color: colors.neutral800,
    lineHeight: '16px',
  },
  memberAddressText: {
    fontSize: 13,
    color: colors.neutral800,
    lineHeight: '16px',
  },
  progressIcon: {
    width: '20px !important',
    height: '20px !important',
  },
  logIcon: {
    width: '16px !important',
    height: '16px !important',
  },
  alertBtn: {
    height: '44px',
    width: '10rem',
    padding: '12px 20px',
    fontSize: '14px',
    fontWeight: 700,
    borderRadius: '4px',
    lineHeight: '20px',
    marginTop: '8px',
  },
  warningText: {
    color: colors.warning500,
  },
  alertText: {
    color: colors.destructive500,
  },
});
